export const faqs = [
  {
    category: "Licenses",
    questions: [
      {
        question: "What types of licenses do you offer?",
        answer: "We offer personal, commercial, and extended licenses to suit your needs. Each license has its own terms of use."
      },
      {
        question: "Can I use a personal license for commercial projects?",
        answer: "No, the personal license is intended for non-commercial projects only. For commercial projects, we recommend purchasing a commercial or extended license."
      },
      {
        question: "What does the extended license include?",
        answer: "The extended license allows the use of the template in multiple commercial projects and limited redistribution within your products."
      },
      {
        question: "How long does the license last?",
        answer: "Our licenses are perpetual, meaning you can use the template indefinitely under the terms of the purchased license."
      },
      {
        question: "Can I transfer my license to someone else?",
        answer: "No, licenses are non-transferable. Each license is linked to the original buyer."
      },
      {
        question: "What happens if I lose my template files?",
        answer: "You can re-download the template from your account as long as it is still available on our platform."
      },
      {
        question: "Can I modify the templates after purchase?",
        answer: "Yes, you can customize the templates as needed, as long as you comply with the terms of the purchased license."
      },
      {
        question: "Do the licenses include technical support?",
        answer: "Yes, we provide technical support to assist you with installation and setup based on the type of license purchased."
      },
      {
        question: "What happens if I use a template without a valid license?",
        answer: "Unauthorized use of our templates may result in legal action. We recommend purchasing the appropriate license to avoid issues."
      }
    ]
  },
  {
    category: "Payments and Downloads",
    questions: [
      {
        question: "What payment methods do you accept?",
        answer: "We accept credit cards, PayPal, and bank transfers to facilitate your purchase."
      },
      {
        question: "Can I get a refund if I'm not satisfied?",
        answer: "Yes, we offer a refund policy within the first 14 days if you are not satisfied, provided you have not downloaded or used the template."
      },
      {
        question: "How do I download my template after purchase?",
        answer: "Once payment is confirmed, you will receive a download link via email, and it will also be available in your account."
      },
      {
        question: "Do the prices include taxes?",
        answer: "The displayed prices include all applicable taxes based on your region."
      },
      {
        question: "Do you offer discounts for bulk purchases?",
        answer: "Yes, we offer volume discounts when purchasing multiple templates in a single transaction."
      },
      {
        question: "Can I buy a template and pay later?",
        answer: "No, all payments must be made at the time of purchase to enable access to the template."
      },
      {
        question: "How long does it take to process my payment?",
        answer: "Payments are processed immediately, and you will receive access to the template within minutes."
      },
      {
        question: "Do you provide invoices for businesses?",
        answer: "Yes, we provide detailed invoices for all purchases. You can enter your company details at checkout."
      },
      {
        question: "Can I upgrade my license after purchase?",
        answer: "Yes, you can upgrade to a higher license by paying only the price difference."
      }
    ]
  },
  {
    category: "Usage and Restrictions",
    questions: [
      {
        question: "Can I resell the templates?",
        answer: "No, reselling our templates is strictly prohibited. You can only use them in final projects for clients."
      },
      {
        question: "Are the templates exclusive?",
        answer: "No, our templates are sold to multiple users. If you need exclusivity, contact us for a custom solution."
      },
      {
        question: "Can I share the template with my team?",
        answer: "Yes, you can share the template with your team as long as they work on the same project under the same license."
      },
      {
        question: "What happens if I violate the terms of use?",
        answer: "Violating the terms of use may result in license termination and potential legal actions."
      },
      {
        question: "Can I use the templates in client projects?",
        answer: "Yes, as long as the purchased license allows it. Commercial and extended licenses are designed for this purpose."
      },
      {
        question: "Can I use the templates for multiple websites?",
        answer: "It depends on the license. Personal and commercial licenses are limited to one project, while the extended license allows multiple uses."
      },
      {
        question: "Do the templates include images and fonts?",
        answer: "Some templates include free images and fonts, but we recommend checking each template's details before purchase."
      },
      {
        question: "Can I use the templates in mobile apps?",
        answer: "Yes, you can use the templates in mobile apps as long as the license terms are respected."
      },
      {
        question: "Are the templates compatible with all browsers?",
        answer: "Yes, all our templates are designed to be compatible with the most popular modern browsers."
      }
    ]
  }
];
